import moment from 'moment';
import { globalDateEntity } from './constants/applicationConstants';
export const sortByField = ({data, key, isAssending=true, secondKey}) =>{
  return data.sort((a,b) => {
    let t = moment(a[key] || a[secondKey] || moment('2000-01-01')).diff(b[key] || b[secondKey] || moment('2000-01-01'));
    return isAssending? -t:t;
  })
}
// To sort arraylist according to key
export const sortDataList = (data, name, isAscending) => {
  // Helper to normalize values: handle nulls, dates and strings
  const getComparable = (val) => {
    if (val === null || val === undefined || val === '') return null;
    // If value is already a Date or number, return timestamp
    if (val instanceof Date) return val.valueOf();
    if (typeof val === 'number') return val;

    // normalize common separators
    const normalized = String(val).replace(/[-_]/g, '/').trim();

    // Try parsing common date formats (month/day/year, year-month-day, etc.)
    const dateFormats = ['MM/DD/YYYY', 'M/D/YYYY', 'MM/DD/YY', 'YYYY/MM/DD', 'YYYY-MM-DD', 'MM-DD-YYYY', 'MM-DD-YY'];
    const m = moment(normalized, dateFormats, true);
    if (m.isValid()) return m.valueOf(); // use timestamp for date comparison

    // fallback to case-insensitive string
    return normalized.toLowerCase();
  };

  return data.sort((a, b) => {
    const va = getComparable(a?.[name]);
    const vb = getComparable(b?.[name]);

    // handle null/empty values: put nulls last when ascending
    if (va === null && vb === null) return 0;
    if (va === null) return isAscending ? 1 : -1;
    if (vb === null) return isAscending ? -1 : 1;

    // both are non-null; compare numbers (dates/timestamps) or strings
    if (typeof va === 'number' && typeof vb === 'number') {
      return isAscending ? va - vb : vb - va;
    }

    if (va > vb) return isAscending ? 1 : -1;
    if (vb > va) return isAscending ? -1 : 1;
    return 0;
  });
};
/**
 * @description
 * redirect with current user token
 * url should be string
 * isOpenNew: if it is true then it will open new tab
 * isClearLocalStorage if yes then it will logged out current app
 */
export const redirectUserWithToken = (url, isClearLocalStorage = false, isOpenNew = false) => {
  const iframe = document.createElement('iframe');
  iframe.src = `${url}/message.html`;
  const accessToken = localStorage.getItem('accessToken');
  const refereshToken = localStorage.getItem('refreshToken');
  const clientID = localStorage.getItem('clientID');
  const username = localStorage.getItem('username');
  const provider = localStorage.getItem('provider');
  document.body.appendChild(iframe);

  iframe.onload = () => {
    iframe.contentWindow.postMessage({'accessToken': accessToken, 'refereshToken': refereshToken, 'username': username, 'clientID': clientID, 'provider': provider}, `${url}`);

    setTimeout(() => {
      if(isClearLocalStorage) {
        localStorage.clear();
      }
      window.open(`${url}`, isOpenNew ? '_blank' : '_self');
      document.body.removeChild(iframe);
    }, 200);
  };
};
// Login user validation msg
export const loginUserValidationError = (errorResponse) => {
  if (errorResponse.status === 422 && errorResponse.data.error_type === "validation_error") {
    return {
      status: true,
      messages: errorResponse.data.error.map(err=>Object.values(err)).join(','),
      error: true
    }
  } else {
    return {
      status: true,
      messages: errorResponse.data.error,
      error: true
    }
  }
};
// Replace date format with correct format for all browser
export const replaceDateFormat = (date) => date.replace(/[-_]/g, '/');
// Filter records with key value
export const filterDataList = (list, key, value, isEqual = false) => {
  return list.filter(function (item) {
    if (!isEqual) {
      return item && item[key] !== value;
    }
  });
};
// Filter records with approved and is_active not equal to n
export const filterDataListWithApprovedForAssociation = (list) => {
  return list.filter(function (item) {
    return item && ((item.is_active !== 'n') && (item.current_status?.toLowerCase() === 'approved' || item.current_status?.toLowerCase() === 'active'));
  });
};
// Create New Record Object for Association List After Add Association
export const addedNewCloneRecordOBJ = (recordTypeName, assoTo, addedRecordData) => {
  return {
    "ASS_PK": addedRecordData.ass_pk,
    "PK": addedRecordData.fe_sent_data.record_associated_to_PK,
    "SK": addedRecordData.fe_sent_data.record_associated_SK,
    "current_status": "ACTIVE",
    "effectivedate": (addedRecordData.fe_sent_data.effectivedate) ? moment(addedRecordData.fe_sent_data.effectivedate).format(globalDateEntity.dateFormat) : null,
    "entity_type": addedRecordData.fe_sent_data.association_to,
    "inactivedate": (addedRecordData.fe_sent_data.inactivedate) ? moment(addedRecordData.fe_sent_data.inactivedate).format(globalDateEntity.dateFormat) : null,
    "instruction_vals": addedRecordData.fe_sent_data.instructionVals ? addedRecordData.fe_sent_data.instructionVals : [],
    "is_latest_version": addedRecordData.fe_sent_data.is_latest_version,
    "link_id": addedRecordData.fe_sent_data.SK,
    "reason": addedRecordData.fe_sent_data.reason,
    "record_number": (addedRecordData.fe_sent_data.record_number) ? addedRecordData.fe_sent_data.record_number : '',
    "record_type": assoTo === "diagnostic_codes" ? addedRecordData?.fe_sent_data?.record_type : recordTypeName,
    "shortname": (addedRecordData.fe_sent_data.shortname) ? addedRecordData.fe_sent_data.shortname : '',
    "title": addedRecordData.fe_sent_data.title,
    "version": addedRecordData.fe_sent_data.version,
    "pa_status": (addedRecordData.fe_sent_data.pa_status) ? addedRecordData.fe_sent_data.pa_status : '',
    "dual_managed": (addedRecordData.fe_sent_data.dual_managed) ? addedRecordData.fe_sent_data.dual_managed : '',
    "optin_status": (addedRecordData.fe_sent_data.optin_status) ? addedRecordData.fe_sent_data.optin_status : '',
    "lob_id": addedRecordData.fe_sent_data.lob_id ? addedRecordData.fe_sent_data.lob_id : '',
  }
};
// Get one date previous from selected date
export const getOneDatPrior = (date) => {
  return new Date (date).setDate(
    new Date (date).getDate() - 1,
  );
};
// Get open end date record from array list
export const findOpenEndDateRecord = (assoDataListData) => {
  return assoDataListData.find((data) => (data.inactivedate === null || data.inactivedate === ''));
};
// Get record which selected date between effective and inactive date from array list
export const filterRecordOverLap = (assoDataListData, selectedEffectiveDate) => {
  return assoDataListData.filter((data) => {
    return ((data.inactivedate !== null) && (moment(selectedEffectiveDate).isBetween(replaceDateFormat(data.effectivedate), replaceDateFormat(data.inactivedate)) || moment(selectedEffectiveDate).isSame(replaceDateFormat(data.effectivedate)) || moment(selectedEffectiveDate).isSame(replaceDateFormat(data.inactivedate))));
  });
};
// Get record after selected date
export const findAfterOneRecordSelectedDate = (assoDataListData, selectedEffectiveDate) => {
  return assoDataListData.find((data) => (data.inactivedate !== null) && (moment(selectedEffectiveDate).isBefore(replaceDateFormat(data.effectivedate))));
};
// Get record before selected date
export const findBeforeOneRecordSelectedDate = (assoDataListData, selectedEffectiveDate) => {
  return assoDataListData.filter((data) => (data.inactivedate !== null) && (moment(selectedEffectiveDate).isAfter(replaceDateFormat(data.effectivedate)))).slice(-1);
};
// Common validation error msgs
export const setValidationMessage = (message, wordsToReplace) => {
  return Object.keys(wordsToReplace).reduce(
    (f, s) => `${f}`.replace(new RegExp(s, 'ig'), wordsToReplace[s]),
    message
  );
}